module.exports = __webpack_public_path__ + "static/media/front.87ab738e.jpg";